const validators = {};

export default validators;



// WEBPACK FOOTER //
// ./src/modules/app/validators/action-validators.js